<template>
    <div>
        <div>
            <Header></Header>
        </div>
        <div class="router-view">
            <div>
                <LeftLevelNavigation></LeftLevelNavigation>
            </div>
            <div class="router-view-main">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    methods: {},
    mounted() {},
}
</script>
<style lang="scss" scoped>
.router-view {
    display: flex;
    .router-view-main {
        width: calc(100% - 250px);
        height: calc(100vh - 80px);
        padding: 20px;
        overflow-y: auto;
    }
}
</style>